import { createContext } from 'react';
import { WawiData } from './config';

export interface AppData {
  static: StaticAppData;
  dynamic: DynamicAppData;
}

export type PriceTable = { [hoehe: number]: { [breite: number]: number } };
export type ValueMapping = { [kEigenschaftWert: number]: number };

export interface StaticAppData {
  wawiData: WawiData;
  artikel: Artikel;
  kategorie: Kategorie;
  config: ArtikelKonfiguration;
  shop: ShopKonfiguration;
  priceTableNetto: PriceTable;
  kEigenschaftWertToValue: ValueMapping;
  kEigenschaftBreite: number;
  kEigenschaftHoehe: number;
  kEigenschaftLaenge: number;
  kEigenschaftTiefe: number;
  kEigenschaftVersand: number | null;
  kEigenschaftMontageart: number;
  kEigenschaftStauhoehe: number;
  kEigenschaftWandschienenhoehe: number;
  kEigenschaftVerstaerkung: number;
}

export interface DynamicAppData {
  invalid: boolean;
  selectedVariationWerte: ArtikelVariationWerte;
}

const AppContext = createContext({} as { appData: AppData, setDynamicAppData: React.Dispatch<React.SetStateAction<DynamicAppData>> });

export default AppContext;
